import { Box, SxProps, Typography, useTheme } from '@mui/material';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

import { SpinnerIcon } from '../../mui-wrapper-components/SpinnerIcon/SpinnerIcon';

export type WorkflowMessageProps = {
  /**
   * The id of the entry
   * @default 'workflow-message'
   */
  id?: string;

  sx?: SxProps;

  /**
   * width of the component
   * @default: 100%
   */
  width?: string | number;

  /**
   * height of the component
   * @default: 348px
   */
  height?: string | number;

  /**
   * title - the title of the workflow message, only used for custom workflowType
   * @default: 'Title'
   */
  title: string;

  /**
   * isLoading - the loading state of the workflow message
   * @default: false
   */
  isLoading?: boolean;

  /**
   * message - the message of the workflow message
   * @default: 'Message'
   */
  message?: string;
};

export function WorkflowMessage(props: WorkflowMessageProps) {
  const {
    id = 'workflow-message',
    sx,
    width = '100%',
    height = '348px',
    isLoading,
    title,
    message,
  } = props;

  const theme = useTheme();

  return (
    <Box
      data-testid={id}
      sx={{
        borderRadius: `${borderRadius.sm}px`,
        // TODO: no VDS token for this value — needs designer input (multi-layer card shadow)
        boxShadow:
          '0px 1px 8px 0px rgba(0, 0, 0, 0.12), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 3px 3px -2px rgba(0, 0, 0, 0.20)',
        padding: theme.spacing(6),
        ...sx,
      }}
    >
      <Box
        data-testid={`${id}-inner`}
        sx={{
          height: height,
          width: width,
        }}
      >
        <Box
          sx={{
            height: height,
            width: width,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignSelf: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {isLoading && <SpinnerIcon id={`${id}-spinnerIcon`} />}
            <Typography variant="h5" data-testid={`${id}-title`}>
              {title}
            </Typography>
            {message && (
              <Typography variant="body1" data-testid={`${id}-message`}>
                {message}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default WorkflowMessage;
